// Values in MUI Spacing
export const TAG_HEIGHT = 2.25
export const TAG_GAP = 0.25
export const DAY_CELL_HEIGHT = 3
